import { ShowHideFlags } from '../schema/types.ts'
import { useChartOptions } from './ChartContext.tsx'

const defaults: Record<keyof ShowHideFlags, boolean> = {
    showZoneDepthText: true,
    showZoneScaleText: true,
}

export default function useFlag(flag: keyof ShowHideFlags) {
    const { chartOptions } = useChartOptions()

    if (typeof chartOptions.flags?.[flag] === 'boolean') {
        return chartOptions.flags[flag]
    }

    return Boolean(defaults[flag])
}
